import create  from 'zustand'
import { authStore } from './AuthStore'

export const useBoundStore = create((...a) => ({
  ...authStore(...a),
}))